module.exports = __webpack_public_path__ + "img/new-line.45ad54a1.svg";